import { render } from "./monthlyDescription.vue?vue&type=template&id=63c7c810&scoped=true"
import script from "./monthlyDescription.vue?vue&type=script&lang=js"
export * from "./monthlyDescription.vue?vue&type=script&lang=js"

import "./monthlyDescription.vue?vue&type=style&index=0&id=63c7c810&scoped=true&lang=scss"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c7c810"]])

export default __exports__